/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * **EXPERIMENTAL** - This icon is still under development, and may change visually.
 *
 *![ExperimentalMicrophoneSparkleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3ElEQVR4nM1VzWsTURBfvWjRXurVXlXsB2LBq6dAoJ2PFV5mEpWcUi/t35C7Ior04L/QQql3L9JQvIg9tBW8So+laBUiQlQmfUlfNlmyWxZ0YGCZN29+M7+ZeRtFgSDiJLDsmtp3eFaIAMsysv4xte9Cg9+v1y8D60EfgPST2UIfJH0PpN+R9A2z3MgU2NOybAF7wUMQZG04564mK0SW40wgXb4TgYeAWD6Yr3NuauCMdLNQAObH1xIVfs1EkdEQ8n8WWA+Iqk/6FJGuJn2iXE0e6IPsl8vlS/74AsYVRZYf5wYwsWyDyw1vAyD9nEZfLgA/UR9Ne4sGI6ZrFACw7iBJKxegv3iS2nzfZOuR79lJpqCl0qMrzWbzYrcqlq3UCkjWzYe5eq83FBkylhWf3dNT2txNW6rh7OUojh9e9zS+9IPxaiwAUe0Osv5GkjZRbe7UJtNIuoEs37pKst4Lbj7I+hNIOojudiaKgOW1L/nLYlyZTfUDnUfWQ1/RWpRnJ5Dknee5DaTPl+LKXbObMtcWkOWFnflE3iYfxrHinJtA1mdA8it9iqRjvAcLmV+WHlRvWRDb7OCR2zMbgM5ERQqeZ3v/OQDYE5C+aPmfhqQgSSv9P6HbhVTxX8tfhWCIoI3P27kAAAAASUVORK5CYII=)
 */
export const ExperimentalMicrophoneSparkleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.04 12c-.37 0-.7.34-.58.7A8 8 0 0 0 11 17.93V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.06A8 8 0 0 0 20 10a1 1 0 1 0-2 0 6 6 0 0 1-11.56 2.27.62.62 0 0 0-.7-.35c-.23.05-.47.08-.7.08Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8 9.94V10a4 4 0 0 0 8 0V6a4 4 0 0 0-4.53-3.97c-.4.06-.47.58-.21.9A3.22 3.22 0 0 1 9.9 8l-1.16.43a.5.5 0 0 0-.3.3L8.01 9.9 8 9.94Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m9.2 3.86-.46-.17-.91-.34a2 2 0 0 1-1.18-1.18L6.14.79a1.21 1.21 0 0 0-2.28 0l-.5 1.38a2 2 0 0 1-1.19 1.18l-1.38.51a1.21 1.21 0 0 0 0 2.28l1.38.5a2 2 0 0 1 1.18 1.19l.51 1.38a1.21 1.21 0 0 0 2.28 0l.5-1.38a2 2 0 0 1 1.19-1.18L8 6.59l1.2-.45a1.21 1.21 0 0 0 0-2.28Z"
        className={colorClass}
      />
    </svg>
  );
};
